const mockLeads = [
  { id: 1, name: 'Sarah Mitchell', company: 'Mitchell Hair Studio', status: 'hot', source: 'Website', date: 'Today', value: '£1,200/yr' },
  { id: 2, name: 'James Harwood', company: 'Harwood Dental', status: 'warm', source: 'Referral', date: 'Yesterday', value: '£2,400/yr' },
  { id: 3, name: 'Emma Clarke', company: 'Clarke Physio', status: 'cold', source: 'Social', date: '3 days ago', value: '£800/yr' },
  { id: 4, name: 'Tom Bennett', company: 'Bennett Builders', status: 'warm', source: 'Website', date: '5 days ago', value: '£1,600/yr' },
];

const statusConfig: Record<string, { color: string; bg: string; label: string }> = {
  hot: { color: 'text-red-400', bg: 'bg-red-400/10 border-red-400/20', label: 'Hot' },
  warm: { color: 'text-amber-400', bg: 'bg-amber-400/10 border-amber-400/20', label: 'Warm' },
  cold: { color: 'text-sky-400', bg: 'bg-sky-400/10 border-sky-400/20', label: 'Cold' },
};

const CrmSection = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-white font-bold text-xl">CRM / Leads</h2>
          <p className="text-ea-gray text-sm mt-0.5">Track and manage your leads pipeline</p>
        </div>
        <a
          href="/contact"
          className="px-4 py-2 bg-ea-blue hover:bg-ea-blue-light text-white text-xs font-semibold rounded-lg transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2"
        >
          <i className="ri-link"></i>
          Connect CRM
        </a>
      </div>

      {/* CTA */}
      <div className="bg-gradient-to-r from-ea-blue/10 to-transparent border border-ea-blue/20 rounded-xl p-6 flex items-center gap-6">
        <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-ea-blue/15 border border-ea-blue/25 shrink-0">
          <i className="ri-contacts-book-2-line text-ea-blue text-xl"></i>
        </div>
        <div className="flex-1">
          <h3 className="text-white font-semibold text-sm mb-1">Connect Your CRM Automation</h3>
          <p className="text-ea-gray text-xs leading-relaxed">
            Automatically capture, qualify and manage leads from your website, social media and other channels, all in one place. Contact us to set up your CRM automation.
          </p>
        </div>
        <a
          href="/contact"
          className="px-4 py-2 bg-ea-blue hover:bg-ea-blue-light text-white text-xs font-semibold rounded-lg transition-colors cursor-pointer whitespace-nowrap shrink-0"
        >
          Get Started
        </a>
      </div>

      {/* Pipeline overview */}
      <div className="grid grid-cols-3 gap-4">
        {[
          { label: 'New Leads', count: '—', icon: 'ri-user-add-line', color: 'text-ea-blue', bg: 'bg-ea-blue/10 border-ea-blue/20' },
          { label: 'In Progress', count: '—', icon: 'ri-refresh-line', color: 'text-amber-400', bg: 'bg-amber-400/10 border-amber-400/20' },
          { label: 'Converted', count: '—', icon: 'ri-check-double-line', color: 'text-green-400', bg: 'bg-green-400/10 border-green-400/20' },
        ].map((item) => (
          <div key={item.label} className={`bg-ea-dark-card border ${item.bg} rounded-xl p-4`}>
            <div className={`w-8 h-8 flex items-center justify-center rounded-lg ${item.bg} border mb-2`}>
              <i className={`${item.icon} ${item.color} text-sm`}></i>
            </div>
            <p className="text-xl font-bold text-white">{item.count}</p>
            <p className="text-ea-gray text-xs mt-0.5">{item.label}</p>
          </div>
        ))}
      </div>

      {/* Sample leads table */}
      <div>
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-white font-semibold text-sm">Sample Lead Pipeline</h3>
          <span className="text-ea-gray/50 text-xs">Demo data. Connect your CRM for real leads.</span>
        </div>
        <div className="bg-ea-dark-card border border-ea-dark-border rounded-xl overflow-hidden">
          <div className="grid grid-cols-5 gap-4 px-5 py-3 border-b border-ea-dark-border">
            {['Contact', 'Company', 'Status', 'Source', 'Est. Value'].map((h) => (
              <p key={h} className="text-ea-gray/60 text-[10px] uppercase tracking-wider font-medium">{h}</p>
            ))}
          </div>
          {mockLeads.map((lead) => {
            const cfg = statusConfig[lead.status];
            return (
              <div key={lead.id} className="grid grid-cols-5 gap-4 px-5 py-4 border-b border-ea-dark-border/50 last:border-0 hover:bg-ea-black/30 transition-colors">
                <div>
                  <p className="text-white text-xs font-medium">{lead.name}</p>
                  <p className="text-ea-gray/50 text-[10px]">{lead.date}</p>
                </div>
                <p className="text-ea-gray text-xs self-center">{lead.company}</p>
                <div className="self-center">
                  <span className={`px-2 py-0.5 rounded-full text-[10px] font-semibold border ${cfg.bg} ${cfg.color}`}>{cfg.label}</span>
                </div>
                <p className="text-ea-gray text-xs self-center">{lead.source}</p>
                <p className="text-ea-blue text-xs font-semibold self-center">{lead.value}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CrmSection;
